<template>
    <div :style="'text-align:'+currentField.alignment+';border-bottom: 1px solid #afb1b6;'">
        <p class="mb-0 heading" :style="'font-size:'+currentField.size+'px;'"><strong>{{currentField.heading}}</strong></p>
        <p class="heading">{{currentField.subheading}}</p>
    </div>
</template>

<script>
export default {
  name: 'Heading',
  props: ['currentField'],
  data() {
    return {
      // input: ''
    };
  },
};
</script>
